import { savePricelist } from 'Slices/Kiosk/TableOptionsSlice'
import { createRequest, handleErrorCatchLog } from '../Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from '../Helpers/TokenHelper'
import { setAllPricelists } from 'Slices/ConfigurationSlice'

const getPricelists = () => (dispatch, getState) => {
  const state = getState()
  const defaultProfileOptions = state.present.configuration.defaultProfileOptions
  const pricelistTypeFilter = state.present.configuration.pricelistTypeFilter

  const omnichannelMarketplaceModule = state.present.configuration.omnichannelModule
  const omnichannelSiteModule = state.present.configuration.omnichannelSiteModule

  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return createRequest(
    `/api/pricelist/?config=${state.present.article.serverConfig}&pricelistTypeFilter=${pricelistTypeFilter}
    &isOmnichannelMarketplaceActive=${omnichannelMarketplaceModule}
    &isOmnichannelSiteActive=${omnichannelSiteModule}`,
    'GET',
    undefined,
    token,
  )
    .then(response => response.json())
    .then(data => {
      dispatch(savePricelist({ data: data, defaultProfileOptions: defaultProfileOptions }))
      dispatch(setAllPricelists(data))
    })
    .catch(err => {
      handleErrorCatchLog(err, 'Failed loading price lists getPricelists')
    })
}

export { getPricelists }
